export const NoResults = ({
  searchString,
}: {
  readonly searchString: string;
}) => (
  <div className="m-auto my-auto p-2 text-center text-tiga-text-lighter">
    <div className="whitespace-nowrap">Es gibt keine Ergebnisse zu</div>
    <div className="whitespace-nowrap">"{searchString}"</div>
  </div>
);
